import { request } from "../lib/http";

export function fetchIntegratorSettings(params) {
  return request({
    url: "integrator/settings",
    method: "get",
    params,
  });
}

export function fetchIntegratorSettingsById(id) {
  return request({
    url: `integrator/settings/${id}`,
    method: "get",
  });
}

export function edit(id, data) {
  return request({
    url: `integrator/settings/${id}`,
    method: "patch",
    data,
  });
}

export function fetchClientsRoteirizations() {
  return request({
    url: `roteirization/clients`,
    method: "get",
  });
}

export function fetchCustomDeliveryDetails(id) {
  return request({
    url: `integrator/custom-delivery-details/${id}`,
    method: "get",
  });
}

export function saveCustomDeliveryDetails({ id, deliveryDetails }) {
  return request({
    url: `integrator/custom-delivery-details/${id}`,
    method: "patch",
    data: { deliveryDetails },
  });
}

export function fetchIntegratorInstallInstructions(params) {
  return request({
    url: "integrator/install-instructions",
    method: "get",
    params,
  });
}

export function fetchIntegratorInstallInstructionsById(id) {
  return request({
    url: `integrator/install-instructions/${id}`,
    method: "get",
  });
}

export function addIntegratorInstallInstructions(data) {
  return request({
    url: `integrator/install-instructions`,
    method: "post",
    data,
  });
}

export function editIntegratorInstallInstructions(id, data) {
  return request({
    url: `integrator/install-instructions/${id}`,
    method: "patch",
    data,
  });
}
